<template>
  <div id="dataRequest">
    <!-- PC端 -->
    <div
      class="PC"
      :style="{
        backgroundImage: flag == 1 ? background.kuanp : background.zhaip,
      }"
    >
      <div class="content1">
        <!-- 头部logo -->
        <div class="content1_top">
          <div class="content1_top_outer">
            <img :src="flag == 1 ? logo.kuanp : logo.zhaip" alt="" />
            <p>对口升学招生管理系统</p>
            <!-- pc端飘动通知 -->
            <div class="flutterNotice" @click="noticeClick(noticeContent)">
              <marquee direction="left" scrollAmount="4">
                <p v-html="noticeContent.notice"></p>
              </marquee>
            </div>
          </div>
        </div>
        <!-- 操作区域 -->
        <div class="content1_outer">
          <div class="content1_bottom">
            <div class="content1_bottom_box">
              <!-- <div class="title">对口升学报名资料审核</div> -->

              <div
                class="box_btn"
                v-for="(item, index) in enrollData"
                :key="index + 'a'"
                @click="pushRoute(item)"
              >
                <!-- <span>审核状态查询(开放时间:3月29日8:00-4月12日17:00)</span> -->
                <span :class="{ Terrace: !item.isShow }">{{ item.name }}</span>
                <img src="../assets/img/jt.png" alt="" />
              </div>
              <div
                class="box_btn"
                v-for="(item, index) in TerraceList"
                :key="index + 'b'"
                @click="Terracejump(item, item.key)"
              >
                <span :class="{ Terrace: !item.isShow }">{{ item.name }}</span>
                <img src="../assets/img/jt.png" alt="" />
              </div>
            </div>
          </div>
        </div>

        <!-- 获取当前时间 -->
        <div class="getTime">
          <div>欢迎{{ userName }}同学登录系统</div>

          <div>
            <span>{{ nowDay }}</span>
            <span>{{ nowTime }} </span>
            <span class="exit" @click="exit">退出</span>
          </div>
        </div>
      </div>
      <!-- pc端报名须知 -->
      <div
        class="notice"
        v-if="shouldKnowobj.showNotice && showNoticecount == 0"
      >
        <div class="notice_word">
          <div class="notice_top">
            <p>{{ shouldKnowobj.name }}</p>
          </div>
          <div class="notice_content customScrollBar">
            <!-- 具体通知内容 -->
            <pdf
              v-for="(item, index) in numPages"
              :key="index + 'c'"
              :src="shouldKnowobj.path"
              :page="item"
              ref="pdf"
            ></pdf>
          </div>
          <div class="notice_bottom1" v-if="showClose" @click="clickClose">
            关闭
          </div>
          <div class="notice_bottom2" v-else>关闭{{ timeCont }}秒</div>
        </div>
      </div>

      <div
        class="technicalSupport"
        :style="{
          color: flag == 1 ? '#fff' : '#000',
        }"
      >
        {{ this.$technicalSupport }}
      </div>
    </div>
    <!-- pc端其他入口强制提醒 -->
    <bmShouldKnow
      v-if="bmShouldKnowData.isNotice"
      :bmShouldKnowData="bmShouldKnowData"
      @clickCloseTerrace="clickCloseTerrace"
      @closeNotice="closeNotice"
    ></bmShouldKnow>

    <!-- pc端支付二维码 -->
    <div class="payQ" :style="flag == 1 ? fixPay.kuanp : fixPay.zhaip">
      <div
        class="payQ_box"
        :style="{
          width: flag == 1 ? '85px' : '55px',
          height: flag == 1 ? '85px' : '55px',
          marginBottom: flag == 1 ? '30px' : '10px',
        }"
      >
        <img src="../assets/img/logo7.jpg" alt="" />
      </div>
      <div
        class="payQ_box2"
        :style="{
          width: flag == 1 ? '85px' : '55px',
          height: flag == 1 ? '85px' : '55px',
        }"
      >
        <img src="../assets/img/12.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import bmShouldKnow from "./bmShouldKnow.vue";

export default {
  components: { bmShouldKnow, pdf },
  data() {
    return {
      background: {
        kuanp: "url(" + require("../assets/img/login_bg2.jpg") + ")",
        zhaip: "url(" + require("../assets/img/bj.png") + ")",
      },
      logo: {
        kuanp: require("../assets/img/logo2.png"),
        zhaip: require("../assets/img/logo2_1.png"),
      },

      fixPay: {
        kuanp: {
          right: "50px",
          bottom: "100px",
        },
        zhaip: {
          right: "10px",
          top: "40px",
        },
      },
      userName: "",
      //资料审核 审核状态
      enrollData: [
        {
          key: "",
          name: "",
          isShow: "",
          routePath: "/selectidentity",
        },
        {
          key: "",
          name: "",
          isShow: "",
          routePath: "/appstatusquery",
        },
      ],
      studentName: "",
      flag: 0,
      // showflag: false, //申请状态查询显示或隐藏(根据后台返回的资料id来判断)
      showflag: true, //申请状态查询显示或隐藏(根据后台返回的资料id来判断)
      showNotice: false,
      showNoticecount: 0, //报名须知关闭次数
      shouldKnowobj: {
        showNotice: false,
        name: "",
        path: "",
      },
      numPages: 0,
      showNoticeName: "",
      article: "",
      timeCont: "5", //报名须知时间,倒计时
      showClose: false,
      nowDay: "",
      nowTime: "",
      noticeContent: "",
      bmShouldKnowData: {
        isNotice: false, //是否需要提示
        name: "", //标题名称
        path: "", //须知内容(pdf路径)
        entrance: "", //其他平台入口地址
        scoreUpload: false,
        routePath: "",
      },
      TerraceList: [
        {
          entrance: "", //其他平台跳转的链接
          id: "2",
          isNotice: true,
          isShow: false,
          key: "pay",
          name: "缴费入口",
          flag: true, //标题名称显示或者隐藏
          uploadTitle: "其他平台入口", //上传文件的文件夹名称
          filename: "", //上传文件的文件名
          path: "", //上传文件的文件路径
        },
        {
          entrance: "",
          id: "3",
          isNotice: true,
          isShow: false,
          key: "admission",
          name: "准考证打印",
          flag: true, //标题名称显示或者隐藏
          uploadTitle: "其他平台入口",
          filename: "", //上传文件的文件名
          routePath: "/searchDataByStudent?type=2",
        },
        {
          entrance: "",
          id: "4",
          isNotice: true,
          isShow: false,
          key: "score",
          name: "分数查询",
          flag: true, //标题名称显示或者隐藏
          uploadTitle: "其他平台入口",
          filename: "", //上传文件的文件名
          path: "",
          routePath: "/searchDataByStudent?type=0",
        },
        {
          entrance: "",
          id: "5",
          isNotice: true,
          isShow: false,
          key: "enroll",
          name: "录取查询",
          flag: true, //标题名称显示或者隐藏
          uploadTitle: "其他平台入口",
          filename: "", //上传文件的文件名
          path: "",
          routePath: "/searchDataByStudent?type=1",
        },
      ],
      Terracetip1: false, //入口提示发放功能
      Terracetip2: false, //入口提示强制阅读
      clickCloseTerraceflag: false,
      bmxzPDFURL: "", // 报名须知的pdf url
    };
  },
  methods: {
    pushRoute(item) {
      if (item.isShow) {
        if (item.routePath == "/selectidentity") {
          this.dataApply();
        } else {
          this.$router.push(item.routePath);
        }
      } else {
        this.$message.info("功能待开放");
      }
    },
    noticeClick(noticeContent) {
      if (noticeContent.noticeFile.path.length > 5) {
        this.bmShouldKnowData.path = noticeContent.noticeFile.path;
        let name = noticeContent.noticeFile.name.replace(".pdf", "");
        this.bmShouldKnowData.name = name;
        this.bmShouldKnowData.isNotice = true;
        this.bmShouldKnowData.routePath = "";
      }
    },
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
        this.getShouldKnow();
      } else {
        this.flag = 2;
        this.getShouldKnow();
      }
    },
    //查看报名须知
    getShouldKnow() {
      this.$request("post", "/terraceSetting/getShouldKnow", null, (data) => {
        console.log("查看报名须知", data);
        if (data.isNotice) {
          this.shouldKnowobj.showNotice = data.isNotice;
          this.shouldKnowobj.name = data.name;
          this.shouldKnowobj.path = data.notice.path;
          this.bmxzPDFURL = data.notice.path;
          this.article = data.shouldKnow;
          // this.countDown(10); //关闭报名须知倒计时
          this.getNumPages();
        } else {
          this.shouldKnowobj.showNotice = data.isNotice;
        }
      });
    },
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.bmxzPDFURL);
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages;
          this.countDown(5); //关闭报名须知倒计时
        })
        .catch((err) => {
          console.error("pdf 加载失败", err);
        });
    },
    //计时装置
    countDown(time) {
      let _this = this;
      time--;
      if (time == 0) {
        _this.timeCont = "";
        this.showClose = true;
        return;
      }
      let timer = setTimeout(function () {
        _this.timeCont = time;
        _this.countDown(time);
      }, 1000);
    },

    //关闭报名须知
    clickClose() {
      // this.showNoticecount = 1;
      sessionStorage.setItem("showNoticecount", 1);
      this.shouldKnowobj.showNotice = false;
    },
    getTerrace() {
      this.$request("post", "/terraceSetting/getTerrace", null, (data) => {
        console.log("查看入口配置", data);
        for (let index = 0; index < this.TerraceList.length; index++) {
          const element = this.TerraceList[index];
          element.id = data[index].id;
          element.key = data[index].key;
          element.name = data[index].name;
          element.isNotice = data[index].isNotice;
          element.isShow = data[index].isShow;
          element.entrance = data[index].entrance; //其他平台跳转的连接
          element.filename = data[index].notice.name;
          element.path = data[index].notice.path;
        }
      });
    },
    //获取前两个列表数据
    getApplyQuery() {
      this.$request("post", "/terraceSetting/getApplyQuery", null, (data) => {
        // debugger
        for (let index = 0; index < this.enrollData.length; index++) {
          const element = this.enrollData[index];
          element.key = data[index].key;
          element.name = data[index].name;
          element.isShow = data[index].isShow;
        }
        console.log("erollData", this.enrollData);
      });
    },
    /**
     * 资料申请
     * 判断当前用户是否填写过资料
     * 若填写过,判断当前用户是应届毕业生还是历届毕业生  应届毕业生跳转至freshgraduate界面 历届毕业生跳转至formerstudents界面
     */
    dataApply() {
      if (
        sessionStorage.getItem("enrollId") == null ||
        sessionStorage.getItem("enrollId") == ""
      ) {
        // 没有申请过
        this.$router.push("/selectidentity");
      } else {
        // 申请过,跳转至资料查询界面 即flag = 0
        this.$request(
          "post",
          "/student/getGraduating",
          { studentId: sessionStorage.getItem("ID") },
          (data) => {
            if (data.graduating == "1" || data.graduating == 1) {
              // 应届毕业生
              this.$router.push("/freshgraduate?flag=0");
            } else {
              // 历届毕业生
              this.$router.push("/formerstudents?flag=0");
            }
          }
        );
      }
    },
    /* 状态查询 */
    dataSearch() {
      this.$router.push("/appstatusquery");
    },
    /* 退出登录 */
    exit() {
      sessionStorage.clear();
      this.$router.push("/");
    },
    currentTime() {
      setInterval(this.getCurrentTime, 500);
    },

    getCurrentTime() {
      var date = new Date();
      var mytime = date.toLocaleTimeString(); //获取当前时间
      date.toLocaleString(); //获取日期与时间

      // 获取当前月份
      var nowMonth = date.getMonth() + 1;

      // 获取当前是几号
      var strDate = date.getDate();

      // 添加分隔符“-”
      var seperator = "-";

      // 对月份进行处理，1-9月在前面添加一个“0”
      if (nowMonth >= 1 && nowMonth <= 9) {
        nowMonth = "0" + nowMonth;
      }

      // 对月份进行处理，1-9号在前面添加一个“0”
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }

      // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
      var nowDate =
        date.getFullYear() + seperator + nowMonth + seperator + strDate;
      this.nowDay = nowDate;
      this.nowTime = mytime;
    },
    //查看公告
    getNotice() {
      this.$request("post", "/getNotice", null, (data) => {
        this.noticeContent = data;
      });
    },
    Terracejump(item, active) {
      switch (active) {
        case "pay": // 缴费入口
          //不开放
          if (item.isShow == false) {
            this.$message("功能待开放");
            return;
          } else {
            //不弹窗提醒
            if (item.isNotice == false) {
              window.open(item.entrance);
            } else {
              //弹窗提醒
              console.log("12313131", item);
              this.bmShouldKnowData.entrance = item.entrance;
              this.bmShouldKnowData.name = item.name;
              this.bmShouldKnowData.path = item.path;
              this.bmShouldKnowData.isNotice = item.isNotice;
              this.bmShouldKnowData.routePath = "";
              this.bmShouldKnowData.scoreUpload = false;
            }
          }

          break;
        case "admission": // 准考证打印
          // this.$message("功能待开放");
          // return;
          // break;
        case "score": // 成绩查询
        case "enroll": // 录取查询
          console.log("111");
          //不开放
          if (item.isShow == false) {
            this.$message("功能待开放");
            return;
          } else {
            //不弹窗提醒
            if (item.isNotice == false) {
              this.$router.push(item.routePath);
            } else {
              //弹窗提醒
              this.bmShouldKnowData.entrance = item.entrance;
              this.bmShouldKnowData.name = item.name;
              this.bmShouldKnowData.path = item.path;
              this.bmShouldKnowData.routePath = item.routePath;
              this.bmShouldKnowData.isNotice = item.isNotice;
              this.bmShouldKnowData.scoreUpload = true;
            }
          }
          break;

        default:
          break;
      }
    },

    clickCloseTerrace(value) {
      this.clickCloseTerraceflag = value;
      this.bmShouldKnowData.isNotice = value;
      if (this.bmShouldKnowData.routePath != "") {
        this.$router.push(this.bmShouldKnowData.routePath);
      } else {
        window.open(this.bmShouldKnowData.entrance);
      }
    },
    closeNotice(flag) {
      this.bmShouldKnowData.isNotice = flag;
    },
  },
  mounted() {
    this.start(); //判断设备
    // this.getNumPages();
    this.currentTime();
    this.getNotice();
    this.getTerrace(); //c查看入口
    this.getApplyQuery();
    this.studentName = sessionStorage.getItem("name");
    if (
      sessionStorage.getItem("showNoticecount") == null ||
      sessionStorage.getItem("showNoticecount") == 0
    ) {
      this.showNoticecount = 0;
    } else {
      this.showNoticecount = 1;
    } // setTimeout(() => {
    //   this.getNumPages();
    // }, 0);

    //判断是否提交过申请材料(enrollId)资料id(没申请过就为空，申请过就有值)
    if (sessionStorage.getItem("enrollId") != "") {
      this.showflag = true;
    }
    this.userName = sessionStorage.getItem("name");
  },
  // 销毁定时器
  beforeDestroy: function () {
    if (this.currentTime) {
      clearInterval(this.currentTime); // 在Vue实例销毁前，清除时间定时器
    }
  },
};
</script>

<style lang="less" scoped>
#dataRequest {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow-y: auto;

  /* PC端 */

  .PC {
    width: 100%;
    height: 100%;
    background: rgba(245, 245, 245, 1);
    background: url("../assets/img/qjbjt.jpg");
    background-size: 100% 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    .content1 {
      width: 100%;
      // height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      margin-bottom: 20px;

      .content1_top {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        box-sizing: border-box;
        margin-top: 80px;
        // margin-bottom: 30px;
        padding-bottom: 1%;

        .content1_top_outer {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          > img {
            width: 350px;
            height: 70px;
            margin-right: 20px;
          }

          > p {
            font-size: 25px;
            // font-family: "SimSun";
            font-weight: 800;
            letter-spacing: 5px;
            margin-left: 20px;
          }
        }
      }

      .content1_outer {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;

        .content1_bottom {
          width: 80%;
          max-width: 550px;
          min-width: 250px;
          box-sizing: border-box;
          opacity: 0.96;
          border-radius: 10px;
          background: rgba(255, 255, 255, 1);
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          position: relative;
          padding: 10px;

          .content1_bottom_box {
            width: 100%;
            display: flex;
            box-sizing: border-box;
            flex-direction: column;
            align-items: center;
            box-sizing: border-box;
            padding: 30px 0;

            .title {
              font-size: 24px;
              font-weight: 400;
              letter-spacing: 2px;
              color: rgba(0, 0, 0, 1);
              margin: 30px 0;
            }

            .box_btn {
              // width: 380px;
              width: 96%;
              height: auto;
              min-height: 45px;
              opacity: 1;
              box-sizing: border-box;
              padding: 0 20px;
              border-radius: 7px;
              background: rgba(0, 79, 146, 1);
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin: 10px 0;

              &:hover {
                cursor: pointer;
              }

              > span {
                font-size: 16px;
                font-weight: 400;
                letter-spacing: 2px;
                // line-height: 0px;
                color: rgba(255, 255, 255, 1);
                text-align: left;
                vertical-align: top;
              }

              .Terrace {
                color: rgb(176, 167, 167);
              }

              > img {
                width: 7px;
                height: 12px;
              }
            }
          }
        }
      }
    }

    .technicalSupport {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: rgb(0, 110, 255);
      margin-bottom: 20px;
    }

    .getTime {
      position: absolute;
      right: 20px;
      top: 20px;
      z-index: 999;

      div {
        margin: 0 3px;
        color: #fff;
        font-size: 15px;
      }

      span {
        margin: 0 3px;
        color: #fff;
        font-size: 15px;
      }

      .exit:hover {
        cursor: pointer;
        color: rgba(0, 79, 146, 1);
      }
    }
  }

  /* 报名通知 */

  .notice {
    position: absolute;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;

    .notice_word {
      width: 900px;
      height: 90%;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 10px;
      box-sizing: border-box;
      padding: 35px;

      .notice_top {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: flex-end;

        > p {
          font-size: 20px;
          font-weight: 700;
          letter-spacing: 3px;
        }
      }

      .notice_content {
        width: 100%;
        height: 800px;
        // height: ;
        flex: 1;
        display: flex;
        overflow-y: auto;
        box-sizing: border-box;
        margin-top: 50px;

        > .p {
          text-align: left;
          text-indent: 2em;
        }

        /deep/ img {
          width: 94% !important;
          height: auto !important;
        }
      }

      .notice_bottom1 {
        width: 50%;
        height: 50px;
        background: rgba(0, 79, 146, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        color: #fff;
        letter-spacing: 5px;
        border-radius: 10px;
        cursor: pointer;
        margin-top: 10px;
      }

      .notice_bottom2 {
        width: 50%;
        height: 50px;
        background: rgba(0, 79, 146, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        color: hsl(0, 0%, 100%);
        letter-spacing: 5px;
        border-radius: 10px;
      }
    }

    .customScrollBar {
      display: flex;
      flex-direction: column;
    }
  }

  /* 飘动通知 */

  .flutterNotice {
    display: flex;
    align-items: center;
    width: 70%;
    max-width: 700px;
    min-width: 280px;
    height: 30px;
    background: rgba(255, 255, 255, 0.635);
    border: 1px solid #054e8e;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;

    &:hover {
      color: #025bc0;
    }

    > marquee {
      font-size: 15px;

      > p {
        text-decoration: none;
      }
    }
  }

  /* 支付二维码 */

  .payQ {
    position: absolute;
    right: 50px;
    bottom: 100px;
    border-radius: 5px;

    .payQ_box {
      width: 85px;
      height: 85px;
      margin: 30px 0;
      overflow: hidden;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;

      > img {
        width: 80%;
        height: 80%;
      }
    }

    .payQ_box2 {
      width: 85px;
      height: 85px;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
